module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_2"
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "tp2"
  }, [_vm._v("BEYOND"), _c('br'), _vm._v("\n    AWKWARD")]), _vm._v(" "), _c('p', {
    staticClass: "tp3"
  }, [_vm._v("When Talking About Jesus"), _c('br'), _vm._v("\n    Is Outside Your Comfort Zone")]), _vm._v(" "), _c('p', {
    staticClass: "tp4"
  }, [_vm._v("BEAU CROSETTO")]), _vm._v(" "), _c('p', {
    staticClass: "tp3"
  }, [_vm._v("Foreword by Dave Ferguson")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('img', {
    attrs: {
      "alt": "IVP Books Imprint",
      "src": "Images/IVP_Books_Quarter.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.IVPress.com/books",
      "target": "_blank"
    }
  }, [_vm._v("www.IVPress.com/books")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e5b7116","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/title_page.vue
// module id = 57
// module chunks = 0